import '../../app.es6';
import angular from 'angular';

class VideoBacklogController {
  /* @ngInject */
  constructor (
    $scope, $sessionStorage, $location,
    commonApiFactory, commonFactory, Const, Page
  ) {
    this.Const = Const;
    this.$scope = $scope;
    this.$sessionStorage = $sessionStorage;
    this.$sessionStorage[this.Const.SSAPP_HAS_HEADER] = true;
    this.$sessionStorage[this.Const.SSAPP_HAS_GRAY] = 'gray';
    this.$sessionStorage[this.Const.SSAPP_MIN_HEIGHT] = '';
    this.$location = $location;
    this.commonApiFactory = commonApiFactory;
    this.commonFactory = commonFactory;
    this.commonFactory.deleteErrorFlg();
    this.schoolName = '';
    this.waitingForPreviewCountSummary = '';
    this.waitingForPublicationCountSummary = '';
    this.guestVideoCountSummary = '';
    this.existenceFlg = true;
    this.memberList = [];

    let role = localStorage.getItem(this.Const.LSAPP_ROLE);
    if (role === this.Const.LSAPP_ROLE_MEMBER) {
      this.$location.path('/member');
    }

    this.getMemberVideoBacklog();

    Page.setTitle(this.Const.TITLE.videoBacklog);

    VideoBacklogController.$inject = [
      '$scope', '$sessionStorage', '$location',
      'commonApiFactory', 'commonFactory', 'Const', 'Page'
    ];
  }

  getMemberVideoBacklog () {
    if (!navigator.onLine) {
      this.commonFactory.flashErrorMessageFlag(this.Const.SSAPP_HAS_NETWORK_ERROR, 3000, false);
      return;
    } else {
      this.commonFactory.overlayShow();
    }
    let reqParams = {
      schoolId: this.$sessionStorage[this.Const.SSAPP_SCHOOL_ID]
    };
    return this.commonApiFactory.getSchoolsSchoolIdMembersVideosBacklogsMembers(reqParams)
      .then((backlog) => {
        if (!backlog) return;

        this.schoolName = this.$sessionStorage[this.Const.SSAPP_SCHOOL_NAME];
        this.waitingForPreviewCountSummary = backlog.videoSummary.waitingForPreviewCount;
        this.waitingForPublicationCountSummary = backlog.videoSummary.waitingForPublicationCount;
        this.existenceFlg = backlog.members && backlog.members.length > 0;

        backlog.members.forEach((member) => {
          let statusList = [
            this.Const.VIDEO_BACKLOG.public,
            this.Const.VIDEO_BACKLOG.preview
          ];
          for (let status of statusList) {
            let countLabel = (status === this.Const.VIDEO_BACKLOG.public ? 'waitingForPublicationCount' : 'waitingForPreviewCount');
            for (let i = 0; i < member.videoSummary[countLabel]; i++) {
              if (member.courses.length !== 0) {
                member.courses.forEach((course) => {
                  this.createViewList(status, member, course);
                });
              } else {
                this.createViewList(status, member, null);
              }
            }
          }
          this.sortViewList(this.memberList);
        });
        return this.commonApiFactory.getSchoolsSchoolIdVideosSummary(reqParams);
      })
      .then((res) => {
        this.guestVideoCountSummary = res.guestVideoCount;
        this.commonFactory.overlayHidden();
        this.$scope.$apply();
      })
      .catch((error) => {
        console.log(error);
        this.commonFactory.overlayHidden();
        this.$scope.$apply();
      });
  }

  createViewList (status, member, course) {
    let viewData = {
      status: status,
      statusLabel: this.Const.VIDEO_BACKLOG_LABEL[status],
      genderImagePath: this.getMemberGenderImagePath(member.gender),
      id: member.id,
      name: member.name,
      courseSubDisplayId: course ? course.subDisplayId : '',
      courseName: course ? course.name : '',
      staffName: course ? this.getStaffName(course.staffs) : ''
    };
    this.memberList.push(viewData);
  }

  sortViewList (list) {
    list.sort((a, b) => {
      if (a.courseSubDisplayId === '') return 1;
      if (b.courseSubDisplayId === '') return -1;
      if (a.courseSubDisplayId > b.courseSubDisplayId) return 1;
      if (a.courseSubDisplayId < b.courseSubDisplayId) return -1;
    });
  }

  getStaffName (staffs) {
    // Array.prototype.find() は古いブラウザでは使えない
    let staff = staffs.filter(v => v.type === 1)[0];
    return staff ? staff.name : '';
  }

  getMemberGenderImagePath (gender) {
    switch (gender) {
      case this.Const.GENDER_TYPE.male:
        return 'res/st_top/common_icon_user_male.png';
      case this.Const.GENDER_TYPE.female:
        return 'res/st_top/common_icon_user_female.png';
      default:
        return 'res/st_top/common_icon_user_default.png';
    }
  }

  toMemberDetail (member) {
    if (!navigator.onLine) {
      this.commonFactory.flashErrorMessageFlag(this.Const.SSAPP_HAS_NETWORK_ERROR, 3000, false);
      return;
    }
    this.$sessionStorage[this.Const.SSAPP_MEMBER_ID] = member.id;
    this.$sessionStorage[this.Const.SSAPP_USER_NAME] = member.name;
    this.$sessionStorage[this.Const.SSAPP_GENDER] = member.gender;
    this.$location.path('/staff/member_detail');
  }

  toGuestVideoList () {
    if (!navigator.onLine) {
      this.commonFactory.flashErrorMessageFlag(this.Const.SSAPP_HAS_NETWORK_ERROR, 3000, false);
      return;
    }
    this.$location.path('/staff/guest_video');
  }
}

angular.module('myApp').controller('VideoBacklogController', VideoBacklogController);



// WEBPACK FOOTER //
// ./app/components/video-backlog/video-backlog-controller.es6